package org.solyton.solawi.bid

import org.solyton.solawi.bid.application.Application

fun main() {
    Application()
}
